import { render, staticRenderFns } from "./gbaLayout.vue?vue&type=template&id=3d09f06e&scoped=true"
import script from "./gbaLayout.vue?vue&type=script&lang=js"
export * from "./gbaLayout.vue?vue&type=script&lang=js"
import style0 from "./gbaLayout.vue?vue&type=style&index=0&id=3d09f06e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d09f06e",
  null
  
)

export default component.exports